import { CommonDomainMarktsegment as Marktsegment } from '@services/identity-api/orval-api/model/commonDomainMarktsegment';

export enum Onderdeel {
  Alerts = 'Alerts',
  Premievaststellingen = 'Premievaststellingen',
  Risicoscan = 'Risicoscan',
  Inspectierapporten = 'Inspectierapporten',
  PtsOverzicht = 'PtsOverzicht',
}

const nietBeschikbareOnderdelen: Record<Marktsegment, readonly Onderdeel[]> = {
  [Marktsegment.Zakelijk]: [],
  [Marktsegment.Particulier]: [
    Onderdeel.Alerts,
    Onderdeel.Premievaststellingen,
    Onderdeel.Risicoscan,
    Onderdeel.Inspectierapporten,
    Onderdeel.PtsOverzicht,
  ],
};

export function isOnderdeelBeschikbaar(
  onderdeel: Onderdeel | undefined,
  marktsegment: Marktsegment | undefined,
): boolean {
  if (!onderdeel) {
    return true;
  }

  return !!marktsegment && !nietBeschikbareOnderdelen[marktsegment].includes(onderdeel);
}
